import React, { Component } from 'react'

class Loader extends Component {
	render() {
		return (
			<div className="w-56 mx-auto space-y-3">
				<div className="h-3 bg-slate-200 rounded-full animate-pulse w-3/4" />
				<div className="h-3 bg-slate-200 rounded-full animate-pulse" />
				<div className="h-3 bg-slate-200 rounded-full animate-pulse w-5/6" />
				<div className="h-3 bg-slate-200 rounded-full animate-pulse w-2/3" />
				<div className="h-3 bg-slate-200 rounded-full animate-pulse w-4/5" />
			</div>
		)
	}
}

export default Loader
